<div class="container-fluid">
  <div class="row">
    <div class="col">
      <h3>Contract Details</h3>
      <hr />
    </div>
  </div>
  @if (contractForm) {
    <form class="row g-3" [formGroup]="contractForm">
      <div class="col-4">
        <label for="contractName" class="form-label"
          >Contract Name<span class="required-field-asterisk">*</span></label
        >
        <input
          type="text"
          class="form-control"
          id="contractName"
          formControlName="contractName"
        />
      </div>
      <div class="col-4">
        <label for="contractStartDate" class="form-label"
          >Contract Start Date<span class="required-field-asterisk"
            >*</span
          ></label
        >
        <input
          type="date"
          class="form-control"
          id="contractStartDate"
          formControlName="startDate"
        />
      </div>
      <div class="col-4">
        <label for="contractExpirationDate" class="form-label"
          >Contract Expiration Date<span class="required-field-asterisk"
            >*</span
          ></label
        >
        <input
          type="date"
          class="form-control"
          id="contractExpirationDate"
          formControlName="expirationDate"
        />
      </div>
      <div class="col-4">
        <label for="cancellationReminderDate" class="form-label"
          >Cancellation Alert Reminder Date</label
        >
        <input
          type="date"
          class="form-control"
          id="cancellationReminderDate"
          formControlName="cancellationReminderDate"
        />
      </div>
      <div class="col-4">
        <label for="contractBillingFrequency" class="form-label"
          >Contract Billing Frequency</label
        >
        <select
          id="contractBillingFrequency"
          class="form-select"
          formControlName="contractFrequency"
        >
          <option [ngValue]="null" disabled selected>Pick one...</option>
          @for (freq of contractFrequencies; track freq) {
            <option [ngValue]="freq.id">
              {{ freq.periodName }}
            </option>
          }
        </select>
      </div>
      <div class="col-4">
        <label for="deliveryMethodOfCancellationNotice" class="form-label"
          >Delivery Method of Cancellation Notice</label
        >
        <select
          id="deliveryMethodOfCancellationNotice"
          class="form-select"
          formControlName="cancellationDeliveryMethod"
        >
          <option [ngValue]="null" disabled selected>Pick one...</option>
          @for (method of deliveryMethods; track method) {
            <option [ngValue]="method">
              {{ method }}
            </option>
          }
        </select>
      </div>
      <div class="col-4">
        <label for="totalContractValue" class="form-label"
          >Total Contract Value ($)</label
        >
        <input
          type="text"
          class="form-control"
          id="totalContractValue"
          [inputMask]="currencyMask"
          placeholder=""
          formControlName="totalContractValue"
        />
      </div>
      <div class="col-4 align-self-center">
        <div class="form-check">
          <label for="earlyTerminationTerms" class="form-check-label"
            >Early Termination Terms?</label
          >
          <input
            type="checkbox"
            id="earlyTerminationTerms"
            class="form-check-input"
            formControlName="earlyTerminationClause"
          />
        </div>
      </div>
      <div class="col-4 align-self-center">
        <div class="form-check">
          <label for="contractAutoRenews" class="form-check-label"
            >Contract Auto-Renews?</label
          >
          <input
            type="checkbox"
            id="contractAutoRenews"
            class="form-check-input"
            formControlName="autoRenewing"
          />
        </div>
      </div>
      @if (contractForm.controls['autoRenewing'].value) {
        <div class="col-4">
          <label for="renewalTerm" class="form-label"
            >Auto-Renewal Term (months)</label
          >
          <input
            type="number"
            id="renewalTerm"
            class="form-control"
            placeholder="# of months"
            formControlName="renewalTerm"
          />
        </div>
      }
    </form>
  }

  <div class="row mt-3">
    <div class="col">
      <h3>Contract Files</h3>
      <hr />
    </div>
  </div>
  <div class="row">
    <div class="col-5">
      <button class="btn btn-primary" (click)="uploadFiles()">
        Upload Contract Files
      </button>
    </div>
    @if (Files && Files.length > 0) {
      <div class="row py-2">
        <div class="col">
          @for (file of Files; track file; let i = $index) {
            @if (file) {
              <div class="row justify-content-between">
                <div class="col">
                  <label>{{ file.filename }}</label>
                  <a
                    (click)="downloadContractDocument(file.id!)"
                    class="text-primary ms-2"
                    role="button"
                  >
                    <i class="bi bi-download fs-28"></i>
                  </a>
                  <a
                    (click)="deleteContractFile(i, file.id)"
                    class="text-danger ms-2"
                    role="button"
                  >
                    <i class="bi bi-trash fs-28"></i>
                  </a>
                </div>
              </div>
            }
          }
        </div>
      </div>
    }
  </div>
</div>
